import React from 'react';
import { CheckCircle2Icon, GiftIcon, TrophyIcon } from 'lucide-react';
import { Section, FadeIn } from './Shared';
export const Product = () => {
  const tomos = [{
    num: '1',
    title: 'Fundamentos GAP: La Base Científica',
    desc: 'Anatomía funcional, biomecánica del movimiento, principios de progresión y los errores más comunes que frenan los resultados de tus alumnas.'
  }, {
    num: '2',
    title: 'Banco de Ejercicios GAP: 100 Movimientos Explicados',
    desc: '100 ejercicios de glúteos, abdomen y piernas con ficha técnica completa, errores frecuentes, variantes y progresiones para cada nivel.'
  }, {
    num: '3',
    title: 'Planificación de Clases GAP: 90 Días de Programación',
    desc: '12 semanas de clases completas listas para dar, con estructura, series, repeticiones y plantillas imprimibles para planificar con autonomía.'
  }, {
    num: '4',
    title: 'GAP con Accesorios: Bandas, Pelota y Aro',
    desc: '65 ejercicios con accesorios explicados, 5 clases modelo combinadas y todo lo que necesitás para llevar tus clases al siguiente nivel.'
  }, {
    num: '5',
    title: 'GAP Terapéutico: Adaptaciones y Poblaciones Especiales',
    desc: 'Protocolos completos para embarazadas, postparto, adultas mayores, lesiones de rodilla, dolor lumbar y diástasis abdominal.'
  }, {
    num: '⭐',
    title: 'Negocio GAP: Monetizá tus Clases y Hacé Crecer tu Estudio',
    desc: 'Cómo armar tu propuesta, fijar precios, crecer en Instagram, scripts de venta, talleres intensivos y métricas para medir el crecimiento de tu estudio.',
    highlight: true
  }];
  const includes = ['Planificación lista para usar desde el primer día', 'Ejercicios con objetivo, desarrollo y progresión', 'Cueings listos para decir palabra por palabra', 'Variaciones Nivel 1, Nivel 2 y Nivel 3 por ejercicio', 'Fichas imprimibles de clase y seguimiento', 'Plantillas de planificación semanal y mensual', 'Adaptaciones para grupos heterogéneos', '100% adaptado a la realidad de las instructoras argentinas'];
  const bonuses = [{
    num: '01',
    title: '50 Fichas de Clase Listas para Imprimir',
    desc: '50 fichas A4 con estructura de clase completa organizadas por nivel y duración. Llevá tu clase planificada al estudio sin improvisar nunca más.',
    value: '$12.000'
  }, {
    num: '02',
    title: '100 Cues de Cueing GAP',
    desc: 'Las palabras exactas para activar, corregir y motivar a tus alumnas en clase. Visuales, kinestésicos y auditivos. Con frases prohibidas y sus alternativas.',
    value: '$9.000'
  }, {
    num: '03',
    title: 'Calendario de Publicaciones GAP para Instagram: 30 Días',
    desc: "30 días de contenido estratégico con captions listos, banco de hashtags, guía de Reels y plantillas de publicación. Nunca más la pregunta '¿qué publico hoy?'.",
    value: '$8.000'
  }, {
    num: '04',
    title: 'Test de Evaluación GAP',
    desc: '12 tests funcionales para medir el progreso de tus alumnas con fichas de seguimiento mensual, gráficos de progreso y protocolo de devolución de resultados.',
    value: '$10.000'
  }, {
    num: '05',
    title: 'Guía de Nutrición Complementaria para Instructoras GAP',
    desc: 'Todo lo que necesitás saber sobre nutrición aplicada al GAP para hablar con criterio con tus alumnas sin reemplazar al nutricionista.',
    value: '$9.000'
  }, {
    num: '06',
    title: 'Kit de Bienvenida para Alumnas GAP',
    desc: 'Carta de bienvenida, reglamento del estudio, ficha de inscripción, compromiso personal, guía de primeros 30 días y tarjeta de turno. Todo listo para entregar desde el día 1.',
    value: '$8.000'
  }];
  return <>
      <Section bg="cream" data-id="element-190">
        <FadeIn className="text-center max-w-4xl mx-auto mb-8 md:mb-16" data-id="element-191">
          <div className="inline-flex items-center gap-2 bg-gold/20 text-yellow-700 font-bold px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm uppercase tracking-wider mb-4 md:mb-6" data-id="element-192">
            <TrophyIcon size={16} data-id="element-193" /> SISTEMA N°1 DE CLASES GAP PARA INSTRUCTORAS
            EN ARGENTINA
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-charcoal mb-4 md:mb-6" data-id="element-194">
            GAP 360™ <br data-id="element-195" />
            <span className="text-coral" data-id="element-196">MEGAPACK — SISTEMA COMPLETO</span>
          </h2>
          <p className="text-xl md:text-2xl font-bold text-rosegold mb-3 md:mb-4" data-id="element-197">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </p>
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-sm md:text-lg font-semibold text-gray-700 mb-5 md:mb-8" data-id="element-198">
            <span data-id="element-199">+300 páginas de contenido estructurado</span>
            <span className="hidden md:inline" data-id="element-200">•</span>
            <span data-id="element-201">100+ ejercicios completos listos para dar</span>
          </div>
          <p className="text-gray-600 text-sm md:text-base mb-5 md:mb-8" data-id="element-202">
            Glúteos · Abdomen · Piernas · Accesorios · Poblaciones Especiales ·
            Negocio GAP
            <br data-id="element-203" />
            Planificación · Progresión · Fidelización · Comunicación
            <br data-id="element-204" />
            <strong data-id="element-205">Funciona desde hoy mismo en tu estudio</strong>
          </p>

          <div className="bg-white p-4 md:p-6 rounded-xl md:rounded-2xl shadow-md border border-gray-100" data-id="element-206">
            <h3 className="font-bold text-gray-500 uppercase tracking-widest text-xs md:text-sm mb-3 md:mb-4" data-id="element-207">
              Niveles y Enfoques Incluidos:
            </h3>
            <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-208">
              {['Principiante', 'Intermedio', 'Avanzado', 'Embarazadas y Postparto', 'Adultas Mayores', 'Online y Presencial'].map((level, i) => <span key={i} className="bg-cream border border-rosegold/30 text-charcoal px-3 py-1.5 md:px-4 md:py-2 rounded-full font-semibold text-xs md:text-base" data-id="element-209">
                  {level}
                </span>)}
            </div>
          </div>
        </FadeIn>

        <div className="max-w-5xl mx-auto" data-id="element-210">
          <div className="text-center mb-8 md:mb-12" data-id="element-211">
            <h3 className="text-2xl md:text-3xl font-bold text-charcoal" data-id="element-212">
              LOS 6 TOMOS
            </h3>
            <p className="text-gray-600 mt-1 md:mt-2 text-sm md:text-base" data-id="element-213">
              Para instructoras que quieren dar clases de GAP con base técnica y
              resultados reales
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-16" data-id="element-214">
            {tomos.map((tomo, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-215">
                <div className={`p-4 md:p-8 rounded-xl md:rounded-2xl border-2 h-full ${tomo.highlight ? 'bg-charcoal text-white border-gold' : 'bg-white border-gray-100 shadow-lg'}`} data-id="element-216">
                  <div className={`w-9 h-9 md:w-12 md:h-12 rounded-full flex items-center justify-center font-bold text-base md:text-xl mb-3 md:mb-6 ${tomo.highlight ? 'bg-gold text-charcoal' : 'bg-coral/10 text-coral'}`} data-id="element-217">
                    {tomo.num}
                  </div>
                  <h4 className={`text-base md:text-xl font-bold mb-2 md:mb-3 ${tomo.highlight ? 'text-gold' : 'text-charcoal'}`} data-id="element-218">
                    {tomo.highlight ? '' : `TOMO ${tomo.num}: `}
                    {tomo.title}
                  </h4>
                  <p className={`text-sm md:text-base ${tomo.highlight ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-219">
                    {tomo.desc}
                  </p>
                </div>
              </FadeIn>)}
          </div>

          <FadeIn className="bg-white p-4 md:p-12 rounded-2xl md:rounded-3xl shadow-xl border border-gray-100" data-id="element-220">
            <h4 className="text-xl md:text-2xl font-bold text-center mb-5 md:mb-8 text-charcoal" data-id="element-221">
              Cada tomo incluye:
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-222">
              {includes.map((item, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-223">
                  <CheckCircle2Icon className="text-green-500 shrink-0 mt-0.5" size={18} data-id="element-224" />
                  <span className="text-gray-700 font-medium text-sm md:text-base" data-id="element-225">
                    {item}
                  </span>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </Section>

      <Section bg="white" data-id="element-226">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-extrabold text-charcoal mb-3 md:mb-4" data-id="element-228">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-lg md:text-xl text-rosegold font-bold" data-id="element-229">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-16" data-id="element-230">
          {bonuses.map((bono, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-231">
              <div className="bg-cream p-4 md:p-8 rounded-xl md:rounded-2xl border border-rosegold/20 relative h-full flex flex-col" data-id="element-232">
                <div className="absolute -top-4 -right-4 md:-top-5 md:-right-5 bg-coral text-white w-9 h-9 md:w-12 md:h-12 rounded-full flex items-center justify-center shadow-lg" data-id="element-233">
                  <GiftIcon size={18} data-id="element-234" />
                </div>
                <h4 className="text-base md:text-xl font-bold text-charcoal mb-2 md:mb-4 pr-6" data-id="element-235">
                  <span className="text-coral" data-id="element-236">Bono {bono.num}</span> —{' '}
                  {bono.title}
                </h4>
                <p className="text-gray-600 text-sm mb-4 md:mb-6 flex-grow" data-id="element-237">
                  {bono.desc}
                </p>
                <div className="flex items-center justify-between mt-auto pt-3 md:pt-4 border-t border-rosegold/20" data-id="element-238">
                  <span className="text-gray-400 line-through font-bold text-sm" data-id="element-239">
                    {bono.value}
                  </span>
                  <span className="bg-green-100 text-green-700 font-extrabold px-3 py-1 rounded-full text-xs md:text-sm" data-id="element-240">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn className="text-center bg-charcoal text-white p-4 md:p-8 rounded-xl md:rounded-2xl max-w-2xl mx-auto shadow-2xl" data-id="element-241">
          <p className="text-gray-400 uppercase tracking-widest text-xs md:text-sm font-bold mb-2" data-id="element-242">
            Valor Total de los 6 Bonos
          </p>
          <p className="text-4xl md:text-5xl font-extrabold text-rosegold line-through mb-2" data-id="element-243">
            $56.000
          </p>
          <p className="text-xl md:text-2xl font-bold text-gold flex items-center justify-center gap-2" data-id="element-244">
            <GiftIcon size={20} data-id="element-245" /> GRATIS — Incluidos siempre
          </p>
        </FadeIn>
      </Section>
    </>;
};